import React from 'react';
import ReactDOM from 'react-dom/client';

// Estilos genéricos de la web
import './styles/texto.css';
import './styles/satoshi.css';
import './styles/elementos.css';

// Componentes
import Router from './router';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(<Router />);